export enum CancellationCode {
    Regret,
    Termination
}